import { padding } from 'polished'

export const __header = () => ({
	height: '40px',
	color: '#777',
	backgroundColor: '#f7f7f7',
	...padding('10', '15', '0'),
	display: 'flex',
	alignItems: 'center',
	fontSize: '12',
	textTransform: 'uppercase',
})
export const __listContainer = () => ({
	backgroundColor: 'white',
})
export const __list = ({ height = '44px' }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	height,
	borderTop: '1px solid #eee',
	...padding('0', '15'),
	textTransform: 'capitalize',
	fontSize: '14',
	'&:last-child': {
		borderBottom: '1px solid #eee',
	},
})

export const __item = ({ theme, isActive }) => ({
	fontSize: '14px',
	fontWeight: '400',
	lineHeight: '18px',
	color: isActive
		? theme.primary(theme).backgroundColor
		: theme.colors.darkGrey4,
})

export const __showMore = ({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	height: '44px',
	borderTop: '1px solid #eee',
	...padding('0', '15'),
	fontSize: '14',
	color: theme.primary(theme).backgroundColor,
})

export const __subCategory = () => ({
	display: 'flex',
	alignItems: 'center',
})

export const __subFilterLabel = ({ theme }) => ({
	fontSize: '14px',
	paddingRight: '10px',
	color: theme.colors.darkGrey5,
	maxWidth: '150px',
	textOverflow: 'ellipsis',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
})

export const __iconWrapper = ({ width, height, theme }) => ({
	width: width || 'inherit',
	height: height || 'inherit',
	color: theme.primary(theme).backgroundColor,
})

export const __accordionHeader = ({ theme }) => ({
	padding: `${theme.spaces[12]} 0`,
})
